import { Box, Tooltip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid/DataGrid";
import { GridColDef } from "@mui/x-data-grid/models/colDef";
import dayjs from "dayjs";
import { useTSelector } from "rx/store";
import { fetchUidData } from "rx/uidmapSlice";
import { useRFirebaseDb } from "utils/FirebaseDbWrapper";
import { useAppDispatch } from "./EventsManager";

var PUSH_CHARS =
  "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
function decodeFBId(id: string) {
  id = id.substring(0, 8);
  var timestamp = 0;
  for (var i = 0; i < id.length; i++) {
    var c = id.charAt(i);
    timestamp = timestamp * 64 + PUSH_CHARS.indexOf(c);
  }
  return timestamp;
}
/*
var key = prompt("Enter Firebase push ID");
if (key) {
  var timestamp = decode(key);
  console.log(timestamp+"\n"+new Date(timestamp));
  alert(timestamp+"\n"+new Date(timestamp));
}*/

type LogEntryAdminDrawer = {
  enableadmin: boolean;
  uid: string;
};
type LogEntryPathChange = {
  path: string;
  value?: string;
  oldvalue?: string;
  uid: string;
};
type LogEntryPathRemoved = {
  path: string;
  value?: string;
  removed: true;
  uid: string;
};
type LogEntryTrackingTime = {
  devid: string;
  endtime: number;
  locationtime: number;
  stoptracking: true;
};

type LogEntry = LogEntryAdminDrawer | LogEntryPathChange | LogEntryPathRemoved | LogEntryTrackingTime;

type OldLogDataType = {
  [year: string]: {
    [month: string]: {
      [day: string]: {
        [ekey: string]: LogEntry;
      };
    };
  };
}; // TODO delete old log data type when old data is goen. Needs new app delivery
type LogDataType =
  | OldLogDataType
  | {
    [ekey: string]: LogEntry;
  };

const ChangesLogDialogContents: React.FC = () => {
  const eventId = useTSelector((state) => state.eventId);
  const logdata = useRFirebaseDb<LogDataType>(`log/${eventId}`);
  const dispatch = useAppDispatch();
  const uidmap = useTSelector((state) => state.uidmap);

  const data = Object.entries(logdata || {}).map(([key, value]) => ({ id: key, ...(value as LogEntry) })).reverse();
  const columns: GridColDef<(typeof data)[number]>[] = [
    {
      field: "id",
      headerName: "Time",
      width: 180,
      valueGetter: (_, row) => {
        return dayjs(decodeFBId(row.id)).format("DD/MM/YYYY HH:mm:ss");
      },
    },
    {
      field: "uid",
      headerName: "User",
      width: 130,
      valueGetter: (_, row) => {
        if (!("uid" in row)) return "Unknown";
        const uentry = uidmap[row.uid];
        if (uentry)
          return (
            uentry.displayName ||
            uentry.email ||
            uentry.phoneNumber ||
            "empty user"
          );
        dispatch(fetchUidData({ uids: [row.uid], eventid: "--" }));
        return row.uid;
      },
    },
    {
      field: "content",
      headerName: "Content?",
      valueGetter: (_, e) => {
        if (typeof e !== "object") return;
        let content: string = JSON.stringify(e);
        if ("enableadmin" in e) {
          content = e.enableadmin
            ? "Enabled admin drawer"
            : "Disabled admin drawer";
        } else if ("path" in e) {
          const s = e.path.split("/");
          if ("removed" in e) {
            content = ".../" + s[s.length - 1] + " removed";
          } else {
            content = ".../" + s[s.length - 1] + ", " + JSON.stringify(e.oldvalue) + " => " + JSON.stringify(e.value);
          }
        } else if ("stoptracking" in e) {
          content = `devid: ${e.devid}, diff: ${e.endtime - e.locationtime},  endtime: ${dayjs(e.endtime).toISOString()}`;
        }
        return content;

      },
      renderCell: (params) => (
        <Tooltip title={
          <pre style={{ margin: 0, fontFamily: "monospace" }}>
            {JSON.stringify(params.row, null, 2)}
          </pre>
        } >
          <span className="table-cell-trucate">{params.value}</span>
        </Tooltip>
      ),
      flex: 1,
    },
  ];
  return (
    <Box sx={{ height: 400, width: "100%" }}>
      <DataGrid
        rows={data}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 50,
            },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default ChangesLogDialogContents;
